import { request } from '../request'

// 获取计划任务列表
export interface GetPlanTaskList {
  limit: number
  page: number
  keyword?: string
  start_time?: string
  end_time?: string
  biz_area?: string
  scheduler_type?: string
}
export const getPlanTaskList = (data: GetPlanTaskList) =>
  request('/portal/verify/dataProtection/jobList', {
    params: data,
  })

// 获取计划详情
export interface GetPlanTaskDetail {
  id: string
}
export const getPlanTaskDetail = (data: GetPlanTaskDetail) =>
  request('/portal/verify/dataProtection/jobDetail', {
    params: {
      ...data,
    },
  })

// 删除计划任务
export interface DeleteTask {
  id_list: string[]
}
export const deletePlanTask = (data: DeleteTask) =>
  request('/portal/verify/dataProtection/batchDeleteJob', {
    method: 'DELETE',
    data,
  })

export const getBizAreaList = () => request('/portal/verify/dataProtection/jobBizAreaList')

export interface ChangeJobStatus {
  id: string
  task_status: number //1:暂停;2:启动
}
export const changeJobStatus = (data: ChangeJobStatus) =>
  request('/portal/verify/dataProtection/changeJobStatus', {
    method: 'PUT',
    data,
  })
